export default "__VITE_ASSET__Do3ImKyJ__"